import localeEnum from '../../../enum/localeEnum'
import NumberStyleEnum from '../../../enum/numberStyleEnum'

export const numberTabFormat = (value: number) => {
	return new Intl.NumberFormat(localeEnum.fr, {
		style: NumberStyleEnum.percent,
		minimumFractionDigits: 3,
		maximumFractionDigits: 3
	}).format(value / 100)
}